import { useGetFeatureTogglesQuery } from '@front/api/service-feature-toggles/useGetFeatureTogglesQuery'
import { getRuntimeConfig } from '@front/runtime-config'
import { mockedFeatureFlags } from '@front/tests/mocks/data/featureFlags.mock'
import type { FeatureFlags } from '@front/type/feature-flags'

const {
  public: { bypassLaunchdarkly },
} = getRuntimeConfig()

const isByPassEnabled = bypassLaunchdarkly === 'true'

export const useFeatureFlags = (): FeatureFlags => {
  const { data } = useGetFeatureTogglesQuery(!isByPassEnabled)

  if (!isByPassEnabled) {
    return (data?.flags || {}) as FeatureFlags
  }

  return mockedFeatureFlags.flags
}
